// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"228":"9bb86039","453":"098cd8c6"}[chunkId] + ".chunk.js";
};